// src/components/atoms/landing/brand-mark.tsx
import Link from "next/link";
import Image from "next/image";
import { cn } from "@/lib/utils";

type BrandMarkProps = {
  href?: string;
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
  src?: string;
  alt?: string;
};

export function BrandMark({
  href = "/",
  className,
  width = 140,
  height = 28,
  priority = false,
  src = "/images/landing/niftipay-logo.svg",
  alt = "NiftiPay",
}: BrandMarkProps) {
  return (
    <Link
      href={href}
      aria-label={`${alt} home`}
      className={cn("inline-flex items-center", className)}
    >
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        priority={priority}
      />
    </Link>
  );
}
